<template>
  <div>
    <div class="card">
      <div class="headerParent d-flex align-items-center justify-content-end">
        <button @click="addNewSection" class="btn btn-outline-secondary">+ اضافه کردن بخش</button>
        <button @click="addNewQuestion" class="primary__button">+ اضافه کردن سوال</button>
      </div>
    </div>

    <div class="card">
      <draggable :group="{ name: 'headline', put: false }" :list="questionsForm.sections" :swapThreshold="1" :animation="200" direction="vertical" @change="onDrag">
        <div v-for="(section, index) in questionsForm.sections" @click="setSectionActiveIndex(index)" :key="index" style="cursor: pointer">
          <div class="mainSection">
            <div class="sectionHeader">
              <BaseText v-if="section.title !== null" v-model="section.title" @focus="setSectionActiveIndex(index)" title="عنوان بخش" />
            </div>
            <!-- placeholder="عنوان بخش"
                required
                :showError="section.checkSectionValidate && !section.title"
                errortext="وارد کردن این فیلد الزامی است" -->

            <div v-for="(question, idx) in section.questions" :key="idx">
              <div @click="setActiveIndex(idx)" class="subSectionContainer">
                <div class="add__remove__container">
                  <div @click="addAnItem(question, index, idx)" class="plus__container">
                    <i class="fa fa-plus"></i>
                  </div>

                  <div @click="removeItem(question, index, idx)" class="minus__container">
                    <i class="fa fa-minus"></i>
                  </div>
                </div>

                <div class="change__sort__button">
                  <div @click="sortUp(index, idx)" class="change__sort">
                    <i class="fas fa-caret-up"></i>
                  </div>

                  <div @click="sortDown(index, idx)" class="change__sort">
                    <i class="fas fa-caret-down"></i>
                  </div>
                </div>

                <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret>
                  <template #button-content>
                    <div class="dropdownButton d-flex justify-content-between align-items-center">
                      <div>{{ question.questionType === 0 ? 'تک انتخابی' : 'چند انتخابی' }}</div>

                      <i style="color: #74788d" class="fas fa-caret-down"></i>
                    </div>
                  </template>

                  <b-dropdown-item @click="changeSectionContent(index, idx, 0)">تک انتخابی</b-dropdown-item>

                  <b-dropdown-item @click="changeSectionContent(index, idx, 1)">چند انتخابی</b-dropdown-item>
                </b-dropdown>

                <div class="w-100 ps-3">
                  <RadioSelection
                    :questions="question"
                    @addRadioOptionClick="onRadioOptionClick(index, idx)"
                    @removeRadioFieldIndex="onRemoveRadioFieldIndex"
                    @checkRadioInput="onCheckRadioInput"
                    @sectionNameChange="onSectionNameChange"
                    :checkQuestionValidate="question.checkQuestionValidate || false"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <Toast :title="toastText" :submit="toastMode" :showToast="showToast" />
      </draggable>
    </div>

    <div class="footer__parent d-flex justify-content-end align-items-center">
      <Button @click.native="addLine" text="انصراف" btnClass="btn-border cancel" />

      <Button @click.native="onSubmit" :disabled="!questionsForm.sections.length" text="ثبت" btnClass="ms-2 approve btn-border" :loading="btnLoading" />
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import Toast from '../../common/Toast.vue'
import Button from '../../common/Button.vue'
import RadioSelection from '../../mooc/headlins/RadioSelection.vue'
import BaseText from '../../common/form/formModules/BaseText.vue'
import skillUpExaminationServices from '../../../services/skillUp/examination'

export default {
  components: {
    Toast,
    Button,
    BaseText,
    draggable,
    RadioSelection,
  },
  data() {
    return {
      submit: false,
      isEdited: true,
      toastText: '',
      showToast: null,
      toastMode: false,
      toggleItems: true,
      toggleInputKey: 1,
      btnLoading: false,
      correctAnswer: '',
      componentsCount: 0,
      toggleMainDiv: true,
      radioComponentKey: 1,
      activeIndex: undefined,
      sectionActiveIndex: null,
      questionsForm: {
        courseSessionFileId: this.courseSessionFileId,
        sections: [],
        title: '',
      },
    }
  },
  props: {
    courseSessionFileId: { type: Number, required: true },
  },
  methods: {
    async onDrag(dragElement) {
      let dragstartElement
      this.questionsForm.sections.forEach((section) => {
        if (section.order === dragElement.moved.newIndex) return (dragstartElement = section)
      })

      dragstartElement.order = dragElement.moved.oldIndex
      dragElement.moved.element.order = dragElement.moved.newIndex

      try {
        const payload = {
          courseSessionFileId: this.questionsForm.courseSessionFileId,
          sections: this.questionsForm.sections,
        }
        const req = await skillUpExaminationServices.editExam(payload)
        if (req.status === 200) {
          this.showToast = false
          this.$nextTick(() => {
            this.toastText = 'تغییرات با موفقیت ذخیره شد.'
            this.toastMode = true
            this.showToast = true
          })
          this.getQuestionsForm()
        }
      } catch (error) {
        console.log(error)
      }
    },
    addLine() {
      this.$emit('addLine')
    },
    onSectionNameChange(payload) {
      this.questionsForm.sections[this.sectionActiveIndex].questions[this.activeIndex].questionText = payload
    },
    onRadioOptionClick(index, idx) {
      this.questionsForm.sections[index]?.questions[idx].answers.push({
        title: '',
        id: undefined,
        isCorrect: false,
        order: this.questionsForm.sections[index].questions[idx].answers.length,
      })
    },
    onRemoveRadioFieldIndex(index) {
      setTimeout(() => {
        let question = this.questionsForm.sections[this.sectionActiveIndex].questions[this.activeIndex]
        question = question.answers.splice(index, 1)
      }, 500)
    },
    onCheckRadioInput(event, index) {
      this.questionsForm.sections[this.sectionActiveIndex].questions[this.activeIndex].answers[index].isCorrect = ['true', true].includes(event) ? true : false
    },
    async getQuestionsForm() {
      console.log(this.$route.query.fileId, this.courseSessionFileId)
      try {
        const req = await skillUpExaminationServices.getExamination(+this.$route.query.fileId || +this.courseSessionFileId)
        if (req.status === 200) this.questionsForm = req.data.data.output
      } catch (error) {
        console.log(error)
      }
    },

    onSubmit() {
      this.questionsForm.sections.forEach((section) => {
        section.questions.forEach((question) => {
          if (!question.questionText.length) question.checkQuestionValidate = true

          question.answers.forEach((answer) => {
            if (!answer.title.length) answer.checkAnswerValidate = true
          })
        })
      })

      if (!this.questionsForm.sections.length) return

      this.btnLoading = true
      this.btnLoading = false

      if (this.questionsForm.sections[0].id) {
        this.editExam()
      } else this.addNewExamination()
    },
    async editExam() {
      let checkValidation = false

      this.questionsForm.sections.forEach((section) => {
        section.questions.forEach((question) => {
          if (question.checkQuestionValidate && !question.questionText.length) checkValidation = true

          question.answers.forEach((answer) => {
            if (answer.checkAnswerValidate && !answer.title.length) checkValidation = true
          })
        })
      })

      if (checkValidation) return
      try {
        const payload = {
          courseSessionFileId: this.questionsForm.courseSessionFileId,
          sections: [this.questionsForm.sections[this.sectionActiveIndex]],
        }

        await skillUpExaminationServices.editExam(payload)

        this.showToast = false
        this.$nextTick(() => {
          this.toastText = 'تغییرات با موفقیت ذخیره شد.'
          this.toastMode = true
          this.showToast = true
        })
        this.getQuestionsForm()
      } catch (error) {
        console.log(error)
      }
    },
    async addNewExamination() {
      let checkValidation = false

      this.questionsForm.sections.forEach((section) => {
        section.questions.forEach((question) => {
          if (question.checkQuestionValidate && !question.questionText.length) checkValidation = true

          question.answers.forEach((answer) => {
            if (answer.checkAnswerValidate && !answer.title.length) checkValidation = true
          })
        })
      })

      if (checkValidation) return
      const sections = this.questionsForm.sections.filter((ex) => !ex.hasOwnProperty('id'))

      const payload = {
        courseSessionFileId: this.questionsForm.courseSessionFileId,
        sections: sections,
      }

      try {
        await skillUpExaminationServices.addExam(payload)

        this.showToast = false
        this.$nextTick(() => {
          this.toastText = 'با موفقیت ذخیره شد.'
          this.toastMode = true
          this.showToast = true
        })

        this.getQuestionsForm()
      } catch (error) {
        console.log(error)
      }
    },
    changeSectionContent(index, idx, type) {
      this.questionsForm.sections[index].questions[idx].answers.forEach((item) => (item.isCorrect = false))
      if (type === 0) {
        this.questionsForm.sections[index].questions[idx].questionType = 0
      } else this.questionsForm.sections[index].questions[idx].questionType = 1
    },
    setActiveIndex(payload) {
      this.$nextTick(() => {
        this.activeIndex = payload
      })
    },
    setSectionActiveIndex(payload) {
      this.$nextTick(() => {
        this.sectionActiveIndex = payload
      })
    },
    addNewQuestion() {
      console.log(this.questionsForm.sections)
      if (this.sectionActiveIndex === null || this.sectionActiveIndex === 0) {
        this.questionsForm.sections.push({
          title: null,
          order: this.questionsForm.sections.length,
          questions: [
            {
              checkQuestionValidate: false,
              questionText: '',
              questionType: 1,
              order: 0,
              answers: [
                {
                  checkAnswerValidate: false,
                  title: '',
                  isCorrect: false,
                  order: 0,
                },
                {
                  checkAnswerValidate: false,
                  title: '',
                  isCorrect: false,
                  order: 1,
                },
              ],
            },
          ],
        })
      } else {
        this.questionsForm.sections[this.sectionActiveIndex].questions.push({
          questionText: '',
          questionType: 1,
          order: this.questionsForm.sections[this.sectionActiveIndex].questions.length,
          answers: [
            {
              title: '',
              isCorrect: false,
              order: 0,
            },
            {
              title: '',
              isCorrect: false,
              order: 1,
            },
          ],
        })
      }
      if (this.sectionActiveIndex) this.setOrder(this.questionsForm.sections[this.sectionActiveIndex].questions)
      else this.setOrder(this.questionsForm.sections[0].questions)
    },
    addNewSection() {
      this.sectionActiveIndex = this.questionsForm.sections.length
      this.questionsForm.sections.push({
        title: '',
        order: this.questionsForm.sections?.length,
        questions: [
          {
            checkQuestionValidate: false,
            questionText: '',
            questionType: 1,
            order: 0,
            answers: [
              {
                checkAnswerValidate: false,
                title: '',
                isCorrect: false,
                order: 0,
              },
              {
                checkAnswerValidate: false,
                title: '',
                isCorrect: false,
                order: 1,
              },
            ],
          },
        ],
      })
    },
    setOrder(array) {
      for (let i = 0; i < array.length; i++) {
        array[i].order = i
      }
    },
    sortUp(index, idx) {
      if (index === 0 || idx === 0) return
      else {
        this.questionsForm.sections[index].questions[idx - 1].order = this.questionsForm.sections[index].questions[idx - 1].order + 1
        this.questionsForm.sections[index].questions[idx].order = this.questionsForm.sections[index].questions[idx].order - 1
        this.questionsForm.sections[index].questions.sort((a, b) => a.order - b.order)
      }
    },
    sortDown(index, idx) {
      if (index === this.questionsForm.sections[index].questions[idx].length - 1) return
      else {
        this.questionsForm.sections[index].questions[idx].order = this.questionsForm.sections[index].questions[idx].order + 1
        this.questionsForm.sections[index].questions[idx + 1].order = this.questionsForm.sections[index].questions[idx + 1].order - 1
        this.questionsForm.sections[index].questions.sort((a, b) => a.order - b.order)
      }
    },
    removeItem(question, sectionIndex, questionIndex) {
      const index = this.questionsForm.sections[sectionIndex].questions.indexOf(question)

      if (index > -1) {
        this.questionsForm.sections[sectionIndex].questions.splice(questionIndex, 1)
        if (this.questionsForm.sections[sectionIndex].questions.length < 1) this.questionsForm.sections.splice(sectionIndex, 1)
      }
      // this.questionsForm.questions[childIndex].questionType.splice(childIndex, 1)
    },
    addAnItem(question, index, idx) {
      const answers = this.getAnswerPayload(question)

      this.questionsForm.sections[index].questions.splice(idx + 1, idx, {
        answers: answers,
        questionType: question.questionType,
      })
      console.log(this.questionsForm.sections[index].questions)
    },
    getAnswerPayload(payload) {
      let answers = []

      for (let index = 0; index < payload.answers?.length; index++) {
        answers.push({ isCorrect: false, order: index, title: '' })
      }

      return answers
    },
  },
  async mounted() {
    await this.getQuestionsForm()
    this.sectionActiveIndex = this.questionsForm.sections.length > 0 ? this.questionsForm.sections.length - 1 : 0
    this.activeIndex = this.questionsForm?.sections[this.sectionActiveIndex]?.questions?.length > 0 ? this.questionsForm.sections[this.sectionActiveIndex].questions.length - 1 : 0
  },
}
</script>

<style lang="scss" scoped>
.headerParent {
  background: white;
  padding: 20px;
  border-radius: 3px;
}
.btn-border {
  border-radius: 4px !important;
}
.approve {
  background-color: #556ee6 !important;
}
.cancel {
  background-color: rgba(51, 51, 51, 0.6) !important;
}

.mainSection {
  border: 1px solid #f0f1f1 !important;
  border-radius: 5px;
}
.sectionHeader {
  padding: 30px;
  border-radius: 5px 5px 0 0;
  background: #f8f9fa;
}
.subSectionContainer {
  padding: 30px;
  border-bottom: 1px solid #eaeaea;
  display: flex;
  align-items: flex-start;
  position: relative;
}
.subSectionContainer:last-child {
  border-radius: 5px;
}
.dropdownButton {
  background: #ffffff;
  border: 1px solid #ced4da;
  box-sizing: border-box;
  border-radius: 4px;
  width: 200px;
  height: 32px;
  padding-right: 20px;
  padding-left: 12px;
}
::v-deep .dropdown-toggle {
  padding: 0 !important;
  color: #444444 !important;
  font-size: 12px !important;
}

.secondary__button {
  padding: 8px 18px;
  color: white;
  background: #74788d;
  border-radius: 5px;
  font-size: 13px;
}
.primary__button {
  background-color: #556ee6;
  padding: 8px 18px;
  box-shadow: none;
  color: white;
  border-radius: 5px;
  font-size: 13px;
  margin-right: 10px;
}
.footer__parent {
  margin-bottom: 20px;
}
.activeSubSection {
  background: #f8f9fa;
  border-top: 1px dashed #ced4da;
  border-bottom: 1px dashed #ced4da;
  &:last-child {
    border-bottom: none;
  }
}
.add__remove__container {
  position: absolute;
  left: -10px;
  top: 50%;
  transform: translateY(-50%);
}
.plus__container {
  background: #34c38f;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  margin-bottom: 10px;
  i {
    color: white;
  }
}
.minus__container {
  background: #ff4861;
  padding: 0 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  i {
    color: white;
  }
}
.change__sort__button {
  position: absolute;
  right: -7px;
  top: 50%;
  transform: translateY(-50%);
}
.change__sort {
  background: #74788d;
  padding: 5px 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  i {
    color: white;
    font-size: 10px;
  }
}
.alert.alert-popUp.alert-dismissible.alert-info {
  padding: 0;
}

::v-deep .card {
  overflow-x: visible;
}
</style>
